<template>
  <div>
    <div style="display: block ruby;width: 60%">

      <el-input v-model="input" placeholder="请输入内容"></el-input>
      <el-button @click = 'PostListplayCode' type="danger">唐唐一键关停按钮</el-button>
<!--      <el-button @click="toggleSelection()">全部启动</el-button>-->
<!--      <el-button @click="shutSelection()">全部关闭</el-button>-->
    </div>




<!--    <el-table-->
<!--      ref="multipleTable"-->
<!--      :data="tableData"-->
<!--      tooltip-effect="dark"-->
<!--      style="width: 100%"-->
<!--      @selection-change="handleSelectionChange">-->
<!--      >-->
<!--      <el-table-column-->
<!--        type="selection"-->
<!--        width="55">-->
<!--      </el-table-column>-->

<!--      <el-table-column-->
<!--        prop="name"-->
<!--        label="计划名称"-->
<!--        width="120">-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        prop="id"-->
<!--        label="计划id"-->
<!--        show-overflow-tooltip>-->
<!--      </el-table-column>-->
<!--      <el-table-column-->
<!--        label="状态"-->
<!--        show-overflow-tooltip>-->
<!--        <template slot-scope="scope">-->
<!--&lt;!&ndash;          // 区别在这行代码&ndash;&gt;-->
<!--&lt;!&ndash;          // <el-switch v-model="scope.row.cazt" :active-value="6" :inactive-value="2" @change="handleChangeStatus($event,scope.row.id)"></el-switch>&ndash;&gt;-->
<!--          <el-switch :value="scope.row.status" :active-value="6" :inactive-value="2" @change="handleChangeStatus(scope.row)"></el-switch>-->
<!--        </template>-->
<!--&lt;!&ndash;        <el-switch&ndash;&gt;-->
<!--&lt;!&ndash;          v-model="value"&ndash;&gt;-->
<!--&lt;!&ndash;          active-color="#13ce66"&ndash;&gt;-->
<!--&lt;!&ndash;          inactive-color="#ff4949">&ndash;&gt;-->
<!--&lt;!&ndash;        </el-switch>&ndash;&gt;-->
<!--      </el-table-column>-->

<!--    </el-table>-->
  </div>


</template>



<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
import {excel} from  '../until/excel';
export default {
  data() {
    return {
      tableData: [{
        name:'',
        id:''
      }],
      startAndStop:0,
      multipleSelection: [],
      input:'',
      value:'',
      rowids:'',
      tttoken:'48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e',
      ttuid:[
        'bf76e2f3665fd1df2588',
        '64d38038434b163595ec',
        '516829fa963025278e35',
        'c0f1d8ef9a0f20a62af3',
        '79d0210099bcdfe7a0dd',
        'a7911b191bfa0d0fa1df',
        'bcf12627afd9b64499d1',
        'aa9d90f0e828c9fb539b',
        '887aec7cd4a7b7cddb1e'

        //测试户 wacai121  122
        // 'd03aa6d90e971e0bb521',
        // '66a7b19ca7a72e1132ca'
      ]
    }
  },
  methods:{

    // 查询计划状态
    async PostListplayCode(){
          this.$confirm('确认拉停唐唐的所有账户吗？', '操作确认', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(()=>{
            this.ttuid.forEach((item,index) => {
              console.log(item)
              let time = parseInt(new Date().getTime()) + '';
              let nonce= Math.round(Math.random() * 100000000000)
              this.$axios.post('api/openapi/v1/ad/campaign/pageInfo?access_token=48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e' + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + item,
                {
                  "lastId":'0',
                  "pageSize":100
                }).then(res=>{
                this.tableData=res.data.data.list
                this.multipleSelection =  this.tableData.map(item => item.id)
                const joinedString = this.multipleSelection.join(',')
                console.log( 'joinedString=' + joinedString);
                let time = parseInt(new Date().getTime()) + '';
                let nonce= Math.round(Math.random() * 100000000000)
                this.$axios.post('/api/openapi/v1/ad/campaign/pause/toggle?access_token=48f971106e4e796cb483ba302a96f0a641a9d5cabfe2b7901d4753c2b137557e' + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=' + item,
                  {
                    "ids":joinedString,
                    "startAndStop":1
                  }
                )
              })

            });
            this.$message.success(this.ttuid+'关停成功')
          })


    },
    updateStatu(){},
    //
    // handleSelectionChange(val) {
    //   this.multipleSelection = val;
    // },
    // shutSelection() {
    //   let time = parseInt(new Date().getTime()) + '';
    //
    //   let nonce= Math.round(Math.random() * 100000000000)
    //   this.multipleSelection.forEach((row,index) => {
    //     // 将字段添加到字符串后面
    //     this.rowids += row.id;
    //
    //     // 如果不是最后一个字段，则添加逗号分隔符
    //     if (index < this.multipleSelection.length - 1) {
    //       this.rowids += ',';
    //     }
    //     console.log(this.rowids)
    //   });
    //   this.$axios.post('/api/openapi/v1/ad/campaign/pause/toggle?access_token=1f36ae8dfbc9403b6ca06e80e3d4d9c6ae0268e990f3019e5bb91df14ea287ea' + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=d03aa6d90e971e0bb521',
    //     {
    //       "ids":this.rowids,
    //       "startAndStop":1
    //     }
    //   )
    // },
    // toggleSelection() {
    //   let time = parseInt(new Date().getTime()) + '';
    //
    //   let nonce= Math.round(Math.random() * 100000000000)
    //   this.multipleSelection.forEach((row,index) => {
    //       // 将字段添加到字符串后面
    //       this.rowids += row.id;
    //
    //       // 如果不是最后一个字段，则添加逗号分隔符
    //       if (index < this.multipleSelection.length - 1) {
    //         this.rowids += ',';
    //       }
    //       console.log(this.rowids)
    //     });
    //   this.$axios.post('/api/openapi/v1/ad/campaign/pause/toggle?access_token=1f36ae8dfbc9403b6ca06e80e3d4d9c6ae0268e990f3019e5bb91df14ea287ea' + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=d03aa6d90e971e0bb521',
    //     {
    //       "ids":this.rowids,
    //       "startAndStop":0
    //     }
    //   )
    // },
    // async handleChangeStatus(row){
    //   let time = parseInt(new Date().getTime()) + '';
    //
    //   let nonce= Math.round(Math.random() * 100000000000)
    //   if (row.status == 2) { // 这里判断一下
    //     // 启用
    //     this.$confirm('确认启用吗？', '操作确认', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning',
    //     })
    //       .then( () => {
    //         this.startAndStop = 0
    //          this.$axios.post('/api/openapi/v1/ad/campaign/pause/toggle?access_token=1f36ae8dfbc9403b6ca06e80e3d4d9c6ae0268e990f3019e5bb91df14ea287ea' + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=d03aa6d90e971e0bb521',
    //           {
    //             "ids":row.id,
    //             "startAndStop":this.startAndStop
    //           }
    //         )
    //         this.$message.success('启用成功')
    //            this.PostListplayCode()
    //       })
    //       .catch(() => {})
    //   } else {
    //     // 禁用
    //     this.$confirm('确认禁用吗？', '操作确认', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning',
    //     })
    //       .then(async () => {
    //         this.startAndStop = 1
    //         await this.$axios.post('/api/openapi/v1/ad/campaign/pause/toggle?access_token=1f36ae8dfbc9403b6ca06e80e3d4d9c6ae0268e990f3019e5bb91df14ea287ea' + '&timestamp=' + time + '&nonce=' + nonce + '&advertiser_id=d03aa6d90e971e0bb521',
    //           {
    //             "ids":row.id,
    //             "startAndStop":this.startAndStop
    //           }
    //         )
    //         this.$message.success('禁用成功')
    //         await   this.PostListplayCode()
    //       })
    //       .catch(() => {})
    //   }
    // }
  },
  created () {  },
}

</script>











































































































































































// WEBPACK FOOTER //
// src/components/tytest.vue